export default __webpack_public_path__ + "static/media/roboto-v27-latin-300.877b9231.woff";